module.exports = __webpack_public_path__ + "img/music.0cc5337b.svg";